import { makeStyles, Typography, Grid, Link } from '@material-ui/core';
import { Children, ReactNode } from 'react';

const useStyles = makeStyles(theme => ({
  value: {
    fontWeight: 'bold',
    overflow: 'hidden',
    lineHeight: '24px',
    wordBreak: 'break-word',
  },
  link: {
    display: 'flex',
    gridAutoFlow: 'column',
    gridAutoColumns: 'min-content',
    gridGap: theme.spacing(3),
  },
  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 'bold',
    letterSpacing: 0.5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}));

type Props = {
  label: string;
  value?: string;
  gridSizes?: Record<string, number>;
  children?: ReactNode;
  url?: string;
};

export const AboutField = ({ label, value, gridSizes, children, url }: Props) => {
  const classes = useStyles();

  // Content is either children or a string prop `value`
  const content = Children.count(children) ? (
    children
  ) : (
    <Typography variant="body2" className={classes.value}>
      {value || `unknown`}
    </Typography>
  );

  if (url !== undefined)
    return (
      <Grid item {...gridSizes}>
        <Typography variant="subtitle2" className={classes.label}>
          {label}
        </Typography>
        <Link className={classes.link} href={url}>
          {content}
        </Link>
      </Grid>
    );
  return (
    <Grid item {...gridSizes}>
      <Typography variant="subtitle2" className={classes.label}>
        {label}
      </Typography>
      {content}
    </Grid>
  );
};
